import Box from "@mui/material/Box";
import { TeamPageHeader } from "./TeamPageHeader";
import { TeamPageList } from "./TeamPageList";

export const TeamPage = () => {
  return (
    <Box pt={2.5} display="flex" flexDirection="column" height="100%">
      <TeamPageHeader />
      <Box
        position="relative"
        bgcolor="background.paper"
        height="100%"
        // borderRadius="4px 4px 0px 0px"
        pt={0.25}
        px={0.25}
      >
        <TeamPageList />
      </Box>
    </Box>
  );
};
